module.exports = __webpack_public_path__ + "img/pasture_panicum_middle.b6aa1dad.webp";